import { FunctionComponent, ReactNode } from "react";
import "./FormField.scss";

interface FormFieldProps {
    label?: ReactNode;
    /** id do input para o for da label */
    htmlFor?: string;
    /** Mensagem de erro embaixo do input. Quando preenchida, aplica estado de erro */
    error?: ReactNode;
    /** Texto de ajuda (cinza, abaixo do input — escondido se houver error) */
    hint?: ReactNode;
    /** Marca como obrigatorio (asterisco) */
    required?: boolean;
    /** Sufixo (ex: "USDT" dentro do input) */
    suffix?: ReactNode;
    /** Prefixo */
    prefix?: ReactNode;
    children: ReactNode;
    className?: string;
}

/**
 * Wrapper de campo de formulario.
 *
 * <FormField label="Nome" error={errors.name}>
 *   <input name="name" />
 * </FormField>
 *
 * O input filho herda o estilo de page-input via classe .ui-input que pode ser
 * aplicada ao filho. Para conveniencia, esse componente NAO injeta classe no
 * filho — voce mantem controle (use a classe page-input do design system se quiser).
 */
const FormField: FunctionComponent<FormFieldProps> = ({
    label,
    htmlFor,
    error,
    hint,
    required,
    suffix,
    prefix,
    children,
    className = "",
}) => {
    const hasAffix = !!suffix || !!prefix;
    return (
        <div className={`ui-form-field ${error ? "has-error" : ""} ${className}`.trim()}>
            {label && (
                <label htmlFor={htmlFor}>
                    {label}
                    {required && <span className="ui-required">*</span>}
                </label>
            )}

            {hasAffix ? (
                <div className="ui-input-affix">
                    {prefix && <span className="ui-prefix">{prefix}</span>}
                    <div className="ui-input-wrap">{children}</div>
                    {suffix && <span className="ui-suffix">{suffix}</span>}
                </div>
            ) : (
                children
            )}

            {error  && <small className="ui-form-error">{error}</small>}
            {!error && hint && <small className="ui-form-hint">{hint}</small>}
        </div>
    );
};

export default FormField;
